window.addEventListener("scroll", function () {
  var styledWith = document.querySelector(".styled-with.diff");
  var tabSection = document.querySelector(".product-details .tab-section");

  if (this.scrollY > 30) {
    styledWith.classList.add("show");
    tabSection.classList.add("hide");
  } else {
    styledWith.classList.remove("show");
    tabSection.classList.remove("hide");
  }

  !(function () {
    var productDetails = document.querySelector(".product-details");

    if (!productDetails) return;

    var sectionRect = productDetails.getBoundingClientRect();
    const sectionBottom = sectionRect.top + sectionRect.height;

    const distanceToBottom = window.innerHeight - sectionBottom;

    // Threshold value to consider the section at the end of the screen
    const threshold = 0; // Adjust as needed

    var content = document.querySelector(".product-details-content");
    
    // Check if the section is at the end of the screen
    if (distanceToBottom >= threshold) {
      // content.style.position  = 'absolute';
      // content.firstElementChild.style.position = 'sticky';
      content.classList.add("absolute");
      
    } else {
      // content.style.position  = 'fixed';
      content.classList.remove("absolute");
      // content.firstElementChild.style.position = 'relative';
    }
  })();
});

var labelsDOM = document.querySelectorAll(".color-box label");
var DOMInputs = document.querySelectorAll(".color-box input");
var colorValue;
var correntItem = DOMInputs[0];

const length = DOMInputs.length;
for (let i = 0; i < length; i++) {
  const item = DOMInputs[i];

  item.addEventListener("change", (e) => {
    colorValue = item.value;
    correntItem = item;
    const colorNameDOM = document.querySelector(".color-title");
    colorNameDOM.innerHTML = item.nextElementSibling.innerText;

    const othersItems = item.parentElement.parentElement.children;
    const length = othersItems.length;
    for (let i = 0; i < length; i++) {
      const item = othersItems[i];
      item.classList.remove("active");
    }

    item.parentElement.classList.add("active");
  });

  const label = labelsDOM[i];
  label.addEventListener("mouseenter", (e) => {
    const colorNameDOM = document.querySelector(".color-title");
    colorNameDOM.innerHTML = label.querySelector("span").innerText;
  });
  label.addEventListener("mouseout", (e) => {
    const colorNameDOM = document.querySelector(".color-title");
    colorNameDOM.innerHTML = correntItem.nextElementSibling.innerText;
  });
}
